import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noValue: {
		id: 'polaris-ideas.view-content.filtered-issue-modal.active-filters.field.datetime.no-value',
		defaultMessage: 'None',
		description: 'Field value if no actual value is available.',
	},
});
